@let result = $result();
<cm-add-item-dialog [title]="title" [confirmButtonText]="confirmButtonText" [confirmDisabled]="!isFormValid" (confirm)="updateOrCreate()">
    <div cm-dialog-content class="cm-edit-job-farm-group-form">
        <cm-input-container>
            <ng-container cm-inline-label>Name:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="result.name" (valueChange)="$result.set({...result, name: $event})"></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Organization:</ng-container>
            <ng-container cm-input>
                <mat-select
                    name="organizationId"
                    placeholder="Organization"
                    [ngModel]="result.organizationId"
                    (ngModelChange)="$result.set({...result, organizationId: $event})"
                    [disabled]="organizations.$editOptions().length <= 1"
                >
                    @for (option of organizations.$editOptions(); track option.state) {
                        <mat-option [value]="option.state">{{ option.label }}</mat-option>
                    }
                </mat-select>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Queue Group:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="result.queueGroup" (valueChange)="$result.set({...result, queueGroup: $event})"></cm-string-input>
            </ng-container>
        </cm-input-container>

        @if (result.id) {
            <div class="cm-delete-section">
                <button mat-button [matMenuTriggerFor]="deleteMenu" type="button">Delete Group</button>
            </div>
        }
    </div>
</cm-add-item-dialog>

<mat-menu #deleteMenu="matMenu">
    <button mat-menu-item (click)="delete()">
        <span>Delete group</span>
    </button>
</mat-menu>
